import useLocalizedData from 'hooks/useLocalizedData';
import React from 'react';
import NOT_FOUND_PAGE_LABELS from './NotFoundPage.labels';

const NotFoundPage = () => {
  const [labels] = useLocalizedData(NOT_FOUND_PAGE_LABELS);
  return (
    <div className="container">
      <h1 className="h1 d-block">{labels.pageTitle}</h1>
      <p>{labels.pageContent}</p>
    </div>
  );
};
export default NotFoundPage;
